import { useDashboard } from '../../hooks/useDashboard';
import styles from './PageSubnav.module.css';

const TABS = [
  {
    id: 'footfall',
    label: 'Footfall',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
      </svg>
    ),
  },
  {
    id: 'compliance',
    label: 'SOP Compliance',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
  },
  {
    id: 'table',
    label: 'Table Monitoring',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
  },
];

export default function PageSubnav({ activeTab, onTabChange, sopCount }) {
  const { activeStore } = useDashboard();
  if (!activeStore) return null;

  return (
    <div className={styles.subnav}>
      <div className={styles.tabs}>
        {TABS.map(t => (
          <button
            key={t.id}
            className={`${styles.tab} ${activeTab === t.id ? styles.active : ''}`}
            onClick={() => onTabChange(t.id)}
          >
            {t.icon}
            {t.label}
            {t.id === 'compliance' && sopCount > 0 && (
              <span className={styles.badge}>{sopCount}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
